import api from './api';

export interface TaskType {
  id: string;
  organizationId: string;
  name: string;
  icon?: string;
  color?: string;
  isDefault: boolean;
  createdAt: string;
  updatedAt?: string;
}

export interface CreateTaskTypeDto {
  name: string;
  icon?: string;
  color?: string;
  isDefault?: boolean;
}

export interface UpdateTaskTypeDto {
  name?: string;
  icon?: string;
  color?: string;
  isDefault?: boolean;
}

class TaskTypeService {
  async getTaskTypes(): Promise<TaskType[]> {
    const response = await api.get('/tasktypes');
    return response.data;
  }

  async getTaskType(id: string): Promise<TaskType> {
    const response = await api.get(`/tasktypes/${id}`);
    return response.data;
  }

  async createTaskType(data: CreateTaskTypeDto): Promise<TaskType> {
    const response = await api.post('/tasktypes', data);
    return response.data;
  }

  async updateTaskType(id: string, data: UpdateTaskTypeDto): Promise<TaskType> {
    const response = await api.put(`/tasktypes/${id}`, data);
    return response.data;
  }

  async deleteTaskType(id: string): Promise<void> {
    await api.delete(`/tasktypes/${id}`);
  }
}

export const taskTypeService = new TaskTypeService();
